export default "__VITE_ASSET__828c31ce__"